// eslint-disable-next-line import/prefer-default-export
export const positionCirclesHandler = (positionType, position) => {
  if (positionType === 'SRP') {
    switch (position) {
      case 'BTNvsBB': {
        return [
          { label: 'BB', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'BTNvsSB': {
        return [
          { label: 'SB', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 96.5, show: true },
        ];
      }
      case 'BTNvsSBvsBB': {
        return [
          { label: 'SB', initialCircleValue: 96.5, show: true },
          { label: 'BB', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 96.5, show: true },
        ];
      }
      case 'COvsBTN': {
        return [
          { label: 'CO', initialCircleValue: 96.5, show: true },
          { label: 'BTN', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'SBvsBB': {
        return [
          { label: 'SB', initialCircleValue: 97, show: true },
          { label: 'BB', initialCircleValue: 97, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'HU_SBvsBB': {
        return [
          { label: 'BB', initialCircleValue: 97, show: true },
          { label: 'SB', initialCircleValue: 97, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'UTGvsBB': {
        return [
          { label: 'BB', initialCircleValue: 96.5, show: true },
          { label: 'EP', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'UTGvsBTN': {
        return [
          { label: 'EP', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'UTGvsBTNvsBB': {
        return [
          { label: 'BB', initialCircleValue: 96.5, show: true },
          { label: 'EP', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 96.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'limpCheck': {
        return [
          { label: 'SB', initialCircleValue: 99, show: true },
          { label: 'BB', initialCircleValue: 99, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'limpRaiseCall': {
        return [
          { label: 'SB', initialCircleValue: 97, show: true },
          { label: 'BB', initialCircleValue: 97, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      default: {
        return [];
      }
    }
  }
  if (positionType === '3bP') {
    switch (position) {
      case 'BTNvsMPvsCO': {
        return [
          { label: 'MP', initialCircleValue: 84.5, show: true },
          { label: 'CO', initialCircleValue: 84.5, show: true },
          { label: 'BTN', initialCircleValue: 84.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'SBvsBTN': {
        return [
          { label: 'SB', initialCircleValue: 88.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 88.5, show: true },
        ];
      }
      case 'BTNvsCO': {
        return [
          { label: 'CO', initialCircleValue: 88, show: true },
          { label: 'BTN', initialCircleValue: 88, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'BBvsSB': {
        return [
          { label: 'SB', initialCircleValue: 91, show: true },
          { label: 'BB', initialCircleValue: 91, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'HU_SBvsBB': {
        return [
          { label: 'BB', initialCircleValue: 91, show: true },
          { label: 'SB', initialCircleValue: 91, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'SBvsCOvsBTN': {
        return [
          { label: 'SB', initialCircleValue: 85, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'CO', initialCircleValue: 85, show: true },
          { label: 'BTN', initialCircleValue: 85, show: true },
        ];
      }
      case 'BTNvsUTG': {
        return [
          { label: 'EP', initialCircleValue: 88, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 88, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'SBvsUTG': {
        return [
          { label: 'SB', initialCircleValue: 88.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'EP', initialCircleValue: 88.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      default: {
        return [];
      }
    }
  }
  if (positionType === '4bP') {
    switch (position) {
      case 'BTNvsSB': {
        return [
          { label: 'SB', initialCircleValue: 64.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 64.5, show: true },
        ];
      }
      case 'COvsBTN': {
        return [
          { label: 'CO', initialCircleValue: 62.5, show: true },
          { label: 'BTN', initialCircleValue: 62.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'SBvsBB': {
        return [
          { label: 'SB', initialCircleValue: 73, show: true },
          { label: 'BB', initialCircleValue: 73, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'HU_SBvsBB': {
        return [
          { label: 'BB', initialCircleValue: 73, show: true },
          { label: 'SB', initialCircleValue: 73, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'UTGvsBTN': {
        return [
          { label: 'EP', initialCircleValue: 62.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'BTN', initialCircleValue: 62.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      case 'UTGvsSB': {
        return [
          { label: 'SB', initialCircleValue: 64.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: 'EP', initialCircleValue: 64.5, show: true },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
          { label: '', initialCircleValue: 0, show: false },
        ];
      }
      default: {
        return [];
      }
    }
  }
  return [];
};

const sixMaxPositions = ['EP', 'MP', 'CO', 'BTN', 'SB', 'BB'];

export const showAllSixMaxPositions = (positionCircles = []) => {
  if (positionCircles.length !== sixMaxPositions.length) return positionCircles;

  const firstPositionIndex = sixMaxPositions.indexOf(positionCircles[0]?.label);
  if (firstPositionIndex < 0) return positionCircles;

  return positionCircles.map((positionCircle, index) => (
    positionCircle.show
      ? positionCircle
      : {
        label: sixMaxPositions[(firstPositionIndex + index) % sixMaxPositions.length],
        initialCircleValue: 100,
        show: true,
        hideCards: true,
      }
  ));
};
